<template>
  <div class="hello client-download-page">
    <div class="download_banner">
      <li style="overflow: hidden;"></li>
      <div class="download_title">
        <h4><img src="../../assets/images/dzh.png" alt="" />终端下载</h4>
        <div style="display: flex;width: 500px;margin: 0 auto;">
          <a href="/api/upload/JeesMTCAutoUpdate/JeesMTCSetup.exe">
            <img
              v-show="!show"
              @mouseover="mouseover_img"
              class="btn_img"
              src="../../assets/images/btn01.png"
              alt=""
            />
            <img
              @mouseout="mouseout_img"
              v-show="show"
              class="btn_img"
              src="../../assets/images/btn02.png"
              alt=""
            />
          </a>
        </div>
      </div>
      <div class="img_box">
        <img class="pcImg" src="../../assets/images/img01.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import '../Tdownload/style.css';

export default {
  name: 'ClientDownload',
  components: {},
  data() {
    return {
      show: false,
    };
  },
  methods: {
    mouseover_img() {
      this.show = true;
    },
    mouseout_img() {
      this.show = false;
    },
  },
};
</script>

<style scoped>
.client-download-page .img_box {
  justify-content: center;
}
.client-download-page .pcImg_r {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/clientDownload/index.vue